import { DocContent } from '../docsData';

const doc: DocContent = {
  title: 'Bullhorn',
  icon: 'https://cdn.app.pliable.co/img/connectors/bullhorn.svg',
  content: `
The Bullhorn connector reads your Bullhorn ATS/CRM data (candidates, client companies and contacts, job orders, submissions, placements, notes, appointments and more) through Bullhorn's REST API. It is **read-only**: Pliable never writes to Bullhorn.

## What you need

Four values:

| Value | What it is |
|---|---|
| **Client ID** | Identifies your Bullhorn API key |
| **Client Secret** | The secret for that API key |
| **API Username** | A Bullhorn user that Pliable signs in as |
| **API Password** | That user's password |

## How to get them

1. **Request an API key.** Contact Bullhorn Support and ask for REST API credentials for your corporation. They will give you a **Client ID** and **Client Secret**. No redirect URL is needed.

2. **Set up an API user.** Use a dedicated Bullhorn user (for example "Pliable Integration") rather than a person's login. Ask Bullhorn Support to enable REST API access for it, and give it view access to the records you want to sync. It must have accepted Bullhorn's Terms of Service, and it cannot be behind single sign-on (SSO) or multi-factor authentication (MFA), because Pliable signs in with the username and password.

> Tip: Use a dedicated service user and ask Bullhorn Support to exempt it from password expiry. Pliable signs in with the username and password on every sync, so if the password changes or expires, syncs stop until you update it in Pliable.

3. **Enter the four values** in Pliable and save.

## Personal contact details

By default, candidate, contact and lead **names, email addresses, phone numbers and street addresses are not synced**. To include them, turn on **Include Personal Contact Details** under Advanced Config. Dates of birth and SSNs are never synced.

## Troubleshooting

- **"Invalid Client Id":** the Client ID is wrong, or the API key is not enabled for your data center.
- **"Bullhorn authorize did not return a code":** check the API username and password, that the user has REST API access, and that it has accepted the Terms of Service. Users behind SSO or MFA cannot be used.
- **Syncs that worked now fail at login:** the API user's password changed or expired, or the user was disabled. Update the password in Pliable.
- **A stream is empty or fails:** the API user cannot see that record type, or your Bullhorn account does not include it (Leads and Opportunities need the Bullhorn CRM module). Give the user view access or deselect the stream.
`,
};

export default doc;
